import { useCallback, useEffect, useState } from 'react';

import type { AgentMessage } from '../types';
import type { PendingUserMessage } from './utils';

interface UsePendingMessagesProps {
  messages: AgentMessage[];
}

export const usePendingMessages = ({ messages }: UsePendingMessagesProps) => {
  const [pendingMessages, setPendingMessages] = useState<PendingUserMessage[]>(
    [],
  );

  useEffect(() => {
    if (pendingMessages.length > 0 && messages.length > 0) {
      setPendingMessages((pending) =>
        pending.filter(
          (pendingMsg) =>
            !messages.some(
              (msg) =>
                msg.userType === 'current' &&
                msg.text.trim().toLowerCase() ===
                  pendingMsg.text.trim().toLowerCase(),
            ),
        ),
      );
    }
  }, [messages, pendingMessages.length]);

  const addPendingMessage = useCallback((message: PendingUserMessage) => {
    setPendingMessages((prev) => [...prev, message]);
  }, []);

  const removePendingMessage = useCallback((messageId: string) => {
    setPendingMessages((prev) => prev.filter((msg) => msg.id !== messageId));
  }, []);

  const clearPendingMessages = useCallback(() => {
    setPendingMessages([]);
  }, []);

  return {
    pendingMessages,
    addPendingMessage,
    removePendingMessage,
    clearPendingMessages,
  };
};
